"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isFluid(width) {
    return width === 'fluid';
}
exports.default = isFluid;
//# sourceMappingURL=FluidHelper.js.map